import { IPaginationLight, TTranslate } from '~/types/main';
import { getTranslate } from '~/utils/helpers';
import { WORKING_HOURS_ORDER_TYPE } from '~/view/screens/BranchesManagementScreen/screens/BranchEditScreen/types/branchEdit';
import { TWorkingTime } from '~/types/workingTime';

type TBranch = {
  id: number;
  name: TTranslate;
  pos_service_id: string;
  franchise_id: number;
  franchise_profile: string;
};

export type TBranchProfilesPagination = IPaginationLight & {
  pages: number[];
};

export type TBranchWorkingTime = TWorkingTime & {
  id: number;
  menuGroupId: number | undefined;
  menuGroupName: string | undefined;
  orderType: WORKING_HOURS_ORDER_TYPE | undefined;
};

export const branchProfileCast = (data: any) => ({
  id: Number(data.id),
  name: String(data.name),
  branches: data.branches.map((branch: any) => ({
    id: Number(branch.id),
    name: branch.name as TTranslate,
    pos_service_id: String(branch.pos_service_id || ''),
    franchise_id: Number(branch.franchise_id),
    franchise_profile: String(branch.franchise_profile),
  })) as TBranch[],
  workingTime: data.timeslots.map((slot: any) => ({
    id: Number(slot.id),
    weekday: String(slot.working_day),
    startTime: String(slot.start_time),
    closeTime: String(slot.close_time),
    menuGroupId: slot.menu_group_id ? Number(slot.menu_group_id) : undefined,
    menuGroupName: getTranslate(slot.menu_group_name),
    orderType: slot.delivery_type as WORKING_HOURS_ORDER_TYPE,
    isNew: false,
  })) as TBranchWorkingTime[],
  editable: Boolean(data.editable),
  created_by: Number(data.created_by), // 0 - taker, 1 - foodics
  deleted_at: String(data.deleted_at),
  is_delete: Number(data.is_delete),
});

export const AllBranchProfiles = (data: any) => ({
  id: Number(data.id),
  name: String(data.name),
  deleted_at: String(data.deleted_at),
  is_delete: Number(data.is_delete),
});

export type TBranchProfile = ReturnType<typeof branchProfileCast>;
